import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/shared/store/authStore';
import { useAuth } from '@/shared/hooks/useAuth';
import { BRAND } from '@/shared/branding';
import { ChangePasswordPage } from '@/features/settings/ChangePasswordPage';

// Shown INSTEAD of the app (no main nav, no sub nav, no AI Companion) while
// the signed-in user still holds a temporary password an admin issued
// (users.must_change_password). Until it is replaced the API refuses every
// other call, so the app shell had nothing real to show: its menu fell back
// to every module. Same look as the sign-in page; once the new password is
// saved the session refreshes and the app opens with the user's own menu.
export function ForcedPasswordChange() {
  const nav = useNavigate();
  const email = useAuthStore((s) => s.user?.email);
  const { logout } = useAuth();

  return (
    <div className="relative min-h-screen min-h-[100dvh] flex flex-col items-center justify-center px-4 py-6 overflow-hidden bg-[#eef0fb]">
      <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="login-blob absolute -top-40 -left-32 h-[34rem] w-[34rem] rounded-full bg-indigo-500/25 blur-[80px]" />
        <div className="login-blob-2 absolute -bottom-48 -right-32 h-[38rem] w-[38rem] rounded-full bg-sky-400/25 blur-[80px]" />
        <div className="login-grid absolute inset-0 opacity-[0.5]"
          style={{ backgroundImage: 'linear-gradient(#6366f114 1px, transparent 1px), linear-gradient(90deg, #6366f114 1px, transparent 1px)', backgroundSize: '40px 40px', maskImage: 'radial-gradient(ellipse 80% 60% at 50% 40%, #000 40%, transparent 100%)' }} />
      </div>

      <main className="relative w-full max-w-[440px]">
        <div className="text-center mb-5">
          <h1 className="text-[1.75rem] font-bold tracking-tight text-[#1e1583] leading-[1.15]">Choose a new password</h1>
          <p className="text-[0.875rem] text-[#5b5a78] mt-2">You are signing in with a temporary password.</p>
        </div>

        <div className="rounded-2xl border border-indigo-100 bg-white/95 backdrop-blur shadow-xl shadow-indigo-300/40 px-6 sm:px-8 py-6">
          <div className="flex justify-center mb-5">
            <img src="/logo-fritech.png" alt={BRAND} className="h-10 w-auto select-none" draggable={false} />
          </div>
          <ChangePasswordPage embedded onDone={() => nav('/', { replace: true })} />
        </div>

        <p className="text-center text-[0.8125rem] text-[#6b6a88] mt-4">
          {email ? <>Signed in as <span className="font-medium">{email}</span> · </> : null}
          <button type="button" onClick={() => { void logout(); }} className="text-[#4338ca] hover:underline focus-ring rounded">Sign out</button>
        </p>
      </main>
    </div>
  );
}
